import { types } from 'mobx-state-tree'
import { payment_methods } from '../api'

const PaymentMethodsStore = types.model({
  loaded: types.optional(types.boolean, false),
  data: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get (token) {
      payment_methods(token).then(
        self.fetchPaymentMethods
      )
    },
    fetchPaymentMethods (data) {
      self.data = data
      self.loaded = true
    }
  })
).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get options () {
      let obj = {}
      return Object.keys(self.data).map((key) => {
        obj = self.data[key]
        return {
          label: obj.name,
          value: obj.id
        }
      })
    }
  })
)

export default PaymentMethodsStore



// WEBPACK FOOTER //
// ./src/stores/PaymentMethodsStore.js